let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lzoL7")).then(() => parcelRequire('1K2XC'));